'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-throttle/~/react/react.js
// module id = 354
// module chunks = 0